<h2 mat-dialog-title>{{ treeDialogueTittle }}</h2>

<mat-dialog-content>
  <loading></loading>
  <div class="management">
    <mat-tree [dataSource]="treeConfig.dataSource" [treeControl]="treeConfig.treeControl" class="example-tree">
            <!-- This is the tree node template for leaf nodes -->
            <!-- There is inline padding applied to this node using styles.
              This padding value depends on the mat-icon-button width. -->
            <mat-tree-node *matTreeNodeDef="let node" matTreeNodeToggle>
                <mat-checkbox
                (change)="selectNode(node)"
                [disabled]="isSelectionDisabled(node)"
                >
                  {{node.Name}}
                </mat-checkbox>
            </mat-tree-node>
            <!-- This is the tree node template for expandable nodes -->
            <mat-nested-tree-node *matTreeNodeDef="let node; when: hasChild">
                <div class="mat-tree-node">
                  <button mat-icon-button matTreeNodeToggle
                          [attr.aria-label]="'Toggle ' + node.Name">
                    <mat-icon class="mat-icon-rtl-mirror">
                      {{treeConfig.treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
                    </mat-icon>
                  </button>
                  <mat-checkbox
                    (change)="selectNode(node)"
                    [disabled]="isSelectionDisabled(node)"
                  >
                    {{node.Name}}
                  </mat-checkbox>
                </div>
                <!-- There is inline padding applied to this div using styles.
                    This padding value depends on the mat-icon-button width.  -->
                <div [class.example-tree-invisible]="!treeConfig.treeControl.isExpanded(node)"
                    role="group">
                  <ng-container matTreeNodeOutlet></ng-container>
              </div>
            </mat-nested-tree-node>
          </mat-tree>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="close()">Cancel</button>
  <div [matTooltip]="addBtnTooltip">
    <button
      [disabled]="isAddButtonDisabled"
      mat-flat-button
      color="primary"
      (click)="add()"
    >
      Add
    </button>
  </div>
</mat-dialog-actions>
